/**
 * The hours question card: the card asks in its own sentence, for exactly what its form takes.
 *
 * The drafting rule's question for `scheduling_policy` names buffers, and the form has no buffer
 * box (it saves 0 minutes, or keeps what was saved). Dawid, terminal picker 2026-10-13 (ledger
 * `d8c226f5`), chose "Card's own sentence": the card asks only when calls are taken, with how much
 * notice and how far ahead. Screen only: the rule's question, which the workflow runs, is unchanged
 * and is still what is stored and logged. The answered card shows the same sentence
 * (`src/card-question.ts`).
 */
import { HOURS_QUESTION } from "../src/card-question.ts";
import { type Draft, AnswerFields as StandingAnswerFields } from "./faq.tsx";

export function HoursQuestionFields({
  idPrefix,
  draft,
  disabled,
  onChange,
}: {
  idPrefix: string;
  draft: Draft;
  disabled: boolean;
  onChange: (next: Partial<Draft>) => void;
}) {
  return (
    <div className="lcr-answer-typed">
      <p>{HOURS_QUESTION}</p>
      <p className="lcr-answer-note">
        These start from common working hours, not from anything the seller said. Check each one
        before saving.
      </p>
      <StandingAnswerFields
        shape="scheduling"
        draft={draft}
        disabled={disabled}
        idPrefix={idPrefix}
        onChange={onChange}
      />
    </div>
  );
}
